export default __webpack_public_path__ + "static/alex_bw-ddb7f019b8d4efaddd0bb67961fca8ec.jpg";